<template>
    <div :class="['BaseDateTime',className]">
        <div class="BaseDateTime__label" v-once>{{translate(label)}}</div>
        <div class="BaseDateTime__date">
            <!--ICON-->
            <i class="BaseDateTime__icon icon-calendar" @click="open({
                        dateString: dateString,
                        title: title,
                        handlerAction: handlerAction,
                        handlerActionParams: handlerActionParams,
                        showTime: showTime
                    })"></i>
            <!--DATE STRING-->
            <BaseText :value="dateString"
                      :errors="errors"
                      :class-name="'BaseDateTime__text'"
                      @change="change" />
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import BaseText from './BaseText.vue';

    export default {
        name: 'BaseDateTime',
        components: {
            BaseText
        },
        props: {
            //The label of the textbox
            label: {
                type: String
            },
            //Shows timepicker if true
            showTime: {
                type: Boolean
            },
            //Date value
            dateString: {
                type: String
            },
            //Title of the dialog
            title: {
                type: String
            },
            //Vuex action for handler
            handlerAction: {
                type: String
            },
            //Handler returning parameters to identify caller
            handlerActionParams: {
            },
            //Form validation errors
            errors: {
                type: Array
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        },
        methods: {
            ...mapActions({
                open: 'dateTimePicker/open'
            }),
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>

    .BaseDateTime__label {
        font-size: 14px;
        color: rgba(96, 125, 139,0.7);
    }

    .BaseDateTime__icon {
        cursor: pointer;
        margin: 7px 4px 0 0px;
        font-size: 20px;
    }

    .BaseDateTime__date {
        display: flex;
        flex-direction: row;
        max-width: 200px;
    }

    .BaseDateTime__text{
        margin-top:0;
    }

</style>



// WEBPACK FOOTER //
// BaseDateTime.vue?4ecc8c76